import React from 'react';
import FAQPage from './FAQPage';

function App() {
  return <FAQPage />;
}

export default App;
